import React from 'react'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

const testimonials = [
  {
    image: require('./../../images/testimonials/pic1.jpg'),
    reviewername: 'Mobile',
    position: 'Available',
    review: ' +964 770 152 4633',
  },
  {
    image: require('./../../images/testimonials/pic2.jpg'),
    reviewername: 'Email',
    position: 'Available',
    review: 'info@askalacompany.com',
  },
  //   {
  //     image: require("./../../images/testimonials/pic3.jpg"),
  //     reviewername: "Barney Smith",
  //     position: "Interior designer",
  //     review:
  //       "Great theme, just what we were looking for. Easy to install, easy to navigate. Well documented. Really enjoyed the support.",
  //   },
  //   {
  //     image: require("./../../images/testimonials/pic4.jpg"),
  //     reviewername: "Rosalina D. William",
  //     position: "Architect",
  //     review:
  //       "Amazing fast and reliable customer support! The team of willing to go mile for customer service! Thanks!",
  //   },
]

var bgimg1 = require('./../../images/background/bg6.jpg')
var bgimg2 = require('./../../images/background/cross-line2.png')

class Testimonials2 extends React.Component {
  render() {
    const options = {
      loop: true,
      autoplay: false,
      margin: 30,
      nav: true,
      dots: false,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        991: {
          items: 2,
        },
      },
    }
    return (
      <>
        <div
          className="section-full mobile-page-padding bg-repeat p-t80 p-b80"
          style={{ backgroundImage: 'url(' + bgimg1 + ')' }}
        >
          <div className="section-content">
            <div className="container">
              {/* TITLE START */}
              <div className="section-head">
                <div
                  className={`${this.props.separatoralignment} sx-separator-outer`}
                >
                  <div
                    className="sx-separator bg-white bg-moving bg-repeat-x"
                    style={{ backgroundImage: 'url(' + bgimg2 + ')' }}
                  >
                    <h3 className="sep-line-one">Contact Us Via</h3>
                  </div>
                </div>
              </div>
              {/* TITLE END */}
              {/* TESTIMONIAL START */}
              <OwlCarousel
                className="owl-carousel testimonial-home-two owl-btn-vertical-center"
                {...options}
              >
                {testimonials.map((item, index) => (
                  <div className="item" key={index}>
                    <div className="testimonial-1 hover-animation-1 bg-gray">
                      <div className="testimonial-detail clearfix">
                        <div className="testimonial-pic  scale-in-center">
                          <img
                            src={item.image}
                            alt=""
                            width={100}
                            height={100}
                          />
                        </div>
                        <span className="testimonial-position">
                          {item.position}
                        </span>
                        <h4 className="testimonial-name">
                          {item.reviewername}
                        </h4>
                        <span className="fa fa-quote-right" />
                      </div>
                      <div className="testimonial-text">
                        <p>{item.review}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>

            {/* <div class="wpo-contact-map-section">
              <iframe
                title="Arbat, Sulaymaniyah Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13004.688045179446!2d45.563370835409536!3d35.425768738672495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fff828e515fd315%3A0xe19e61c6f93b1de0!2sArbat%2C%20Sulaymaniyah%20Governorate!5e0!3m2!1sen!2siq!4v1748515249952!5m2!1sen!2siq"
                allowFullScreen
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div> */}
          </div>
        </div>
      </>
    )
  }
}

export default Testimonials2
